import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CoreModule,
    RecaptchaV3Module,
    BrowserAnimationsModule,
    SharedModule
  ],  
  providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: "6LeoUskaAAAAABrOeSdEhNCoqRKs-mDefAITRI6a" }],
  bootstrap: [AppComponent]
})
export class AppModule { }
